// extracted by mini-css-extract-plugin
export default {"auth-page":"auth-page__nkzUL","auth-container":"auth-container__r6e7W","auth-form":"auth-form__VI6yp","login-link":"login-link___q1Gb"};